import { useEventCallback } from '@mui/material';
import { Fragment, ReactElement, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useNavigate, useParams } from 'react-router-dom';
import { EditTypeOperationCrubs } from 'practice/constants/type-operation-crubs';
import FormTypeOperation, { FormTypeOperationVM } from 'practice/components/type-operation/form';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { toast } from 'react-toastify';
import { TypeOperationData } from 'shell/models/type-operation';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { typeOperationResponseTransformer } from 'practice/utils/typeoperation-response-transformer';

const EditTypeOperation = (): ReactElement => {
  const navigate = useNavigate();

  const params = useParams();

  const onCancel = useEventCallback(() => {
    navigate('/pratiche/ricerca-tipo-operazione');
  });

  const [typeOperation] = useHttpFetch<HttpResponse<TypeOperationData>, FormTypeOperationVM>(
    `${__PRACTICE_API_URL__}/pratiche/tipo-operazione/${params?.tyPratica}/${params?.tyOperazione}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {
          key: {
            tipoPratica: params?.tyPratica,
            tipoOperazione: params?.tyOperazione,
            codiceEnte: params?.code,
          },
        },
      },
      transformer: typeOperationResponseTransformer,
    }
  );

  const updateTypeOperation = useHttpClient(`${__PRACTICE_API_URL__}/pratiche/tipo-operazione/`, {
    options: {
      errorCatching: true,
      method: 'PUT',
      loading: true,
      data: {},
    },
  });

  const onSubmit = useCallback(
    (values: FormTypeOperationVM) => {
      (
        updateTypeOperation({
          data: {
            descrizioneBreveTipoOperazione: values.descriptionBrief || null,
            descrizioneTipoOperazione: values.description || null,
            codiceTipoDocumento: values.typeDocument || null,
            flagStampaDocumento: values.printDoc || null,
            codiceMotivo: values.codeMovement || null,
            flagOperazioneInUso: values.inUse || null,
            key: {
              tipoPratica: values.practice,
              tipoOperazione: values.code,
            },
          },
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/pratiche/ricerca-tipo-operazione');
      });
    },
    [navigate, updateTypeOperation]
  );

  return (
    <Fragment>
      <Breadcrumbs items={EditTypeOperationCrubs} />
      {typeOperation.isLoading || typeOperation.pristine || typeOperation.hasErrors ? undefined : (
        <FormTypeOperation
          title="Modifica Tipo Operazione"
          onCancel={onCancel}
          isEdit
          onSubmit={onSubmit}
          initialValues={typeOperation?.data as FormTypeOperationVM}
        />
      )}
    </Fragment>
  );
};

EditTypeOperation.displayName = 'Edit Type Practice Page component';

export default EditTypeOperation;
